var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"horizontal-menu-container"},[_c('list',{staticClass:"horizontal-menu",attrs:{"data":_vm.horizonMenuItems,"type":"horizontal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }